// @flow
import React, { useEffect, useState } from 'react'
import { hot } from 'react-hot-loader/root'
import renderHTML from 'react-render-html'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/search.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { ParliamentComponent } from 'components/parliament'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { LocaleContext } from '../../contexts/locale'
import { Dashboard } from '../dashboard'

// TODO Set the correct article ID here
const ARTICLE_ID = '31277704'

function AppComponent() {
  // const [locale, setLocale] = useState<'de' | 'fr' | 'en'>('de')
  const [locale, setLocale] = useState<'de' | 'fr' | 'en'>('de')
  const domain = parseHostname().publicationDomain

  // Get site language
  useEffect(() => {
    // Download language
    window
      .fetch(`https://m.${domain}/api/sites/default`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status.toString())
      })
      .then(data => {
        setLocale('de')
        // setLocale(data.site.language)
      })
      .catch(error => {
        console.warn(error)
      })
  }, [domain, ARTICLE_ID])

  const messages = require('locales/' + locale + '.yml')

  return (
    <div className='index'>
      <LocaleContext.Provider value={locale}>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              {renderHTML(messages.Content.Title)}
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                {messages.Content.IntroText}
              </div>
            </h2>
            <p className='ta author'>{messages.Content.ByLine}</p>
          </div>
        </header>

        <header className='ui vertical segment'>
          <h3 className='ui infographic center aligned header'>
            {messages.UI.Global.Councils.nr}
          </h3>
          <div className='ui text center aligned container'>
            <h5>{messages.UI.Global.Other.FraktionenNR}</h5>
            <Dashboard data={require('../../stores/nationalrat-data.csv')} />
          </div>
          <section className='parliament-container nr'>
            <ParliamentComponent
              locale={messages}
              council='nr'
              sheetURL='https://docs.google.com/spreadsheets/d/1uDe_b_4425TTBMHa2CsPpZ33HBbMAbC5HgE-9u0UuZA/'
            />
          </section>
        </header>

        <header className='ui vertical segment'>
          <h3 className='ui infographic center aligned header'>
            {messages.UI.Global.Councils.sr}
          </h3>
          <div className='ui center aligned text container'>
            <h5>{messages.UI.Global.Other.FraktionenSR}</h5>
            <Dashboard data={require('../../stores/staenderat-data.csv')} />
          </div>
          <section className='parliament-container sr'>
            <ParliamentComponent
              sheetURL='https://docs.google.com/spreadsheets/d/1uDe_b_4425TTBMHa2CsPpZ33HBbMAbC5HgE-9u0UuZA/'
              council='sr'
            />
          </section>
        </header>

        <Footer
          hidePortfolioTeaser
          articleId={ARTICLE_ID}
          credits={messages.credits}
          questions={messages.userFeedbackQuestions}
        />
      </LocaleContext.Provider>
    </div>
  )
}

export default hot(AppComponent)
